import { render, staticRenderFns } from "./BottomActionbar.vue?vue&type=template&id=2ba3ce76&scoped=true"
import script from "./BottomActionbar.vue?vue&type=script&lang=js"
export * from "./BottomActionbar.vue?vue&type=script&lang=js"
import style0 from "./BottomActionbar.vue?vue&type=style&index=0&id=2ba3ce76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3ce76",
  null
  
)

export default component.exports